export class RoleStatusRequest {
    roleId: number;
    active: boolean;
}